<template>

  <div>
    <!-- END: Data List -->
    <div id="new-rough-purchase-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <a data-dismiss="modal" href="javascript:;">
            <XIcon class="w-8 h-8 text-gray-500" />
          </a>
          <div class="modal-body p-10">
            <!-- <div id="vertical-form"> -->
            <div class="flex flex-col justify-between mt-5">
              <!-- BEGIN: Data List -->
              <div class="intro-y overflow-auto">
                <div class="flex items-center">
                  <h2 class="intro-y text-lg font-medium mr-5" v-if="form_data.id == ''">New Purchase</h2>
                  <h2 class="intro-y text-lg font-medium mr-5" v-else>Purchase No : <span class="ml-2 text-primary-1">{{
                    form_data.lot_no }}</span></h2>
                </div>
              </div>
              <div class="grid grid-cols-12 gap-4">
                <div class="intro-y col-span-12">
                  <!-- BEGIN: Input -->
                  <div class="">
                    <div id="input" class="py-5">
                      <div class="preview" v-if="(form_data.purchase_select == false && form_data.purchase_type == 2) || form_data.purchase_type == 1">

                        <div v-if="[1, 2, 8].includes(user_details.user_role)">
                          <div class="sm:grid gap-2"
                          :class="{ 'grid-cols-3': settings && (settings['PURCHASE_PARTY_VISIBLE'] == 1), 'grid-cols-2': settings && (settings['PURCHASE_PARTY_VISIBLE'] == 0) }"
                          >

                            <div>
                              <div v-if="!form_data.id">

                                <label class="form-label">Purchase Type</label>
                                <TomSelect v-model="form_data.purchase_type" :options="{
                                  placeholder: 'Select Type'
                                }" class="w-full">
                                  <option value="1">Rough Purchase</option>
                                  <option value="2">Rejection Purchase</option>
                                </TomSelect>

                              </div>
                              <div v-if="form_data.id">

                                <label class="form-label">Purchase Type</label>
                                <TomSelect disabled v-model="form_data.purchase_type" :options="{
                                  placeholder: 'Select Type'
                                }" class="w-full">
                                  <option value="1">Rough Purchase</option>
                                  <option value="2">Rejection Purchase</option>
                                </TomSelect>

                              </div>
                            </div>

                            <div class="mt-2 sm:mt-0">
                              <label class="form-label">Select Vendor</label>
                              <TomSelect v-model="form_data.party" @change="getHomeParty" :options="{
                                placeholder: 'Select Vendor'
                              }" class="w-full">
                                <!-- <option value="0">Select Party</option> -->
                                <option v-for="(party, index) in page_data.party_details" :key="index"
                                  :value="party.id">
                                  {{ party.first_name }} {{ party.last_name }}</option>
                              </TomSelect>
                            </div>

                            <div class="mt-2 sm:mt-0" v-if="settings && settings['PURCHASE_PARTY_VISIBLE'] == 1">
                              <label class="form-label">Select Party</label>
                              <TomSelect v-model="form_data.purchase_party" :options="{
                                placeholder: 'Select Party'
                              }" class="w-full">
                                <option value="0">Select Party</option>
                                <option v-for="(party, index) in page_data.purchase_party_details" :key="index"
                                  :value="party.id">{{ party.first_name }} {{ party.last_name }}</option>
                              </TomSelect>
                            </div>

                          </div>
                        </div>
                        <div class="mt-3">

                          <div class="sm:grid gap-2"
                          :class="{ 'grid-cols-3': settings && (settings['DIAMOND_TYPE_VISIBLE'] == 1), 'grid-cols-2': settings && (settings['DIAMOND_TYPE_VISIBLE'] == 0) }">

                            <div>
                              <div id="form-label" class="">Purchase Type</div>
                              <select class="form-select mt-2" v-model="form_data.packet_type"
                                aria-label="Default select example">
                                <option value="makeable">Makeable</option>
                                <option value="rough">Rough</option>
                              </select>
                            </div>
                            <div class="mt-2 sm:mt-0" v-if="settings && settings['DIAMOND_TYPE_VISIBLE'] == 1">
                              <label class="form-label">Select Diaomond Type</label>
                              <TomSelect v-model="form_data.diamond_type" :options="{
                                placeholder: 'Select Diaomond Type'
                              }" class="w-full">
                                <option value="0">Select Diaomond Type</option>
                                <option v-for="(party, index) in page_data.diamond_type_items" :key="index"
                                  :value="party.id">{{ party.type }}</option>
                              </TomSelect>
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <label class="form-label">Select Stone Type  <span class="text-theme-6"> * </span></label>

                              <TomSelect v-model="form_data.stone_id" :options="{
                                placeholder: 'Select Stone Type'
                              }" class="w-full">
                                <option value="0">Select Stone Type</option>
                                <option v-for="(party, index) in page_data.stones" :key="index"
                                  :value="party.id">{{ party.stone_name }}</option>
                              </TomSelect>
                            </div>

                          </div>

                        </div>

                        <div class="mt-3">

                          <div class="sm:grid grid-cols-3 gap-2"
                          :class="{ 'grid-cols-3': settings && (!settings['CUSTOM_STOCK_SEQUENCE'] || (settings['CUSTOM_STOCK_SEQUENCE'] == '')), 'grid-cols-2': settings && (settings['CUSTOM_STOCK_SEQUENCE'] != '') }"
                          >

                            <div v-if="settings && !settings['CUSTOM_STOCK_SEQUENCE']">
                              <div class="">
                                <div id="input-group-4">Kapan <span class="text-theme-6"> * </span></div>

                                <input id="pos-form-1" v-model="form_data.kapan" name="kapan" type="text"
                                  class="form-control flex-1" placeholder="Kapan No" />
                              </div>
                            </div>
                            <div class="mt-2 sm:mt-0">

                                <div class="">
                                  <div id="input-group-3" :class="{ 'border-theme-6': form_validate.weight.$error }">
                                    Pieces <span class="text-theme-6"> * </span></div>
                                  <input type="text" class="form-control" name="piece"
                                    :class="{ 'border-theme-6': form_validate.piece.$error }" autocomplete="off"
                                    @keypress="$h.preventInvalidInput" v-model="form_data.piece"
                                    placeholder="No of Pieces" aria-describedby="input-group-3" />
                                </div>
                                <template v-if="form_validate.piece.$error">
                                  <div v-for="(error, index) in form_validate.piece.$errors" :key="index"
                                    class="text-theme-6 mt-2">
                                    {{ error.$message }}
                                  </div>
                                </template>

                              </div>
                              <div class="mt-2 sm:mt-0">
                              <div class="">
                                <div id="input-group-4" :class="{ 'border-theme-6': form_validate.weight.$error }">
                                  Weight (Ct) <span class="text-theme-6"> * </span></div>
                                <input type="text" class="form-control" name="weight"
                                  :class="{ 'border-theme-6': form_validate.weight.$error }" autocomplete="off"
                                  @keypress="$h.preventInvalidInput" @change="calculate_purchase_ct('weight')" v-model="form_data.weight" placeholder="Weight"
                                  aria-describedby="input-group-4" />
                              </div>
                              <template v-if="form_validate.weight.$error">
                                <div v-for="(error, index) in form_validate.weight.$errors" :key="index"
                                  class="text-theme-6 mt-2">
                                  {{ error.$message }}
                                </div>
                              </template>
                            </div>

                          </div>

                        </div>
                        <div class="mt-3" v-if="page_data.home_party == 1">

                          <div class="sm:grid grid-cols-3 gap-2">

                            <div>
                              <div id="input-group-4">
                                <!-- <input type="checkbox" v-model="page_data.per_ct_allow" @click="page_data.total_allow = !page_data.total_allow" /> -->
                                Per/Ct Rate</div>
                              <input @change="calculate_purchase_ct('per_ct_rate')" :disabled="page_data.total_allow" type="text" class="form-control"
                                v-model="form_data.per_ct_rate" placeholder="Per Carat Rate ($)"
                                aria-describedby="input-group-4" />
                            </div>
                            <div class="mt-2 sm:mt-0">
                              <div id="input-group-4">
                                <input type="checkbox" v-model="page_data.total_allow" @click="page_data.per_ct_allow = !page_data.per_ct_allow" />
                                Total Amount</div>
                              <input @change="calculate_purchase_ct('total_rate')" :disabled="page_data.per_ct_allow" type="text" class="form-control"
                                v-model="form_data.total_rate" placeholder="Total Rate ($)"
                                aria-describedby="input-group-4" />
                            </div>
                            <div class="">
                              <div id="input-group-3">Duration</div>
                              <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                                v-model="form_data.due" placeholder="Duration" aria-describedby="input-group-3" />
                            </div>

                          </div>

                        </div>
                        <div class="mt-3" v-if="page_data.home_party == 1">

                          <div class="sm:grid grid-cols-3 gap-2">

                            <div>
                              <div id="input-group-3">Majuri Type</div>
                              <select class="form-select" v-model="form_data.majuri_type" @change="get_margin_costing"
                                aria-label="Default select example">
                                <option value="1">Percent(%)</option>
                                <option value="2">Fixed</option>
                              </select>
                            </div>
                            <div class="mt-2 sm:mt-0">
                                <div id="input-group-4">Est. Majuri</div>
                                <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                                  v-model="form_data.majuri_rate" placeholder="Majuri"
                                  aria-describedby="input-group-4" />
                              </div>
                            <div class="mt-2 sm:mt-0">
                                <div id="input-group-4">Est. Margin</div>
                                <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                                  v-model="form_data.margin_percent" placeholder="Margin (%)"
                                  aria-describedby="input-group-4" />
                              </div>

                          </div>

                        </div>
                        <div class="mt-3">

                          <div class="sm:grid grid-cols-3 gap-2">

                            <div class="mt-2 sm:mt-0">
                              <div id="input-group-4">LS Loss(%)</div>
                              <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                                v-model="form_data.ls_loss_per" placeholder="LS Loss (%)"
                                aria-describedby="input-group-4" />
                            </div>
                            <div class="mt-2 sm:mt-0"></div>
                            <div class="flex justify-end items-center mt-5 w-100">
                                  <button type="button" :disabled="page_data.loading == true"
                                    class="btn btn-secondary w-24 m-auto mr-1" data-dismiss="modal"
                                    href="javascript:;">Cancel</button>
                                  <button v-if="form_data.purchase_type == 1" type="button" @click="add_purchase"
                                    :disabled="page_data.loading == true" class="btn btn-primary w-24">{{
                                      form_data.id ? 'Update' :
                                        'Create' }}
                                    <LogInIcon v-if="page_data.loading == false" class="h-4 w-4 ml-2 -mt-1" />
                                    <LoadingIcon v-if="page_data.loading == true" icon="oval" color="white"
                                      class="w-4 h-4 ml-2" />
                                  </button>
                                  <button v-if="form_data.purchase_type == 2 && form_data.purchase_select == false"
                                    type="button" @click="form_data.purchase_select = true"
                                    class="btn btn-primary w-24">Next</button>
                                </div>

                          </div>

                        </div>
                      </div>
                      <div class="preview" v-if="(form_data.purchase_select == true && form_data.purchase_type == 2)">
                        <div>
                          <div>

                            <label class="form-label">Select Kapan</label>
                            <TomSelect v-model="form_data.purchase_list" multiple :options="{
                              placeholder: 'Select Kapan'
                            }" class="w-full">
                              <!-- <option value="0">Select Party</option> -->
                              <option v-for="(party, index) in page_data.rejection_items" :key="index"
                                :value="party.kapan_id">{{ party.lot_no
                                }} ({{ party.voucher_no }})</option>
                            </TomSelect>

                          </div>
                        </div>
                        <div class="mt-3">
                          <div>

                            <table class="w-full border">
                              <thead>
                                <tr class="border-b bg-gray-200 dark:bg-dark-1">
                                  <!-- <th class="py-2 border-b text-xs lg:text-md text-center border-r"> # </th> -->
                                  <td class="py-2 border-b text-center border-r">NO</td>
                                  <td class="py-2 border-b text-center border-r">Kapan No</td>
                                  <td class="py-2 border-b text-center border-r">Avail. PCS</td>
                                  <td class="py-2 border-b text-center border-r">Avail. Wt (Ct)</td>
                                  <td class="py-2 border-b text-center border-r">New PCS</td>
                                  <td class="py-2 border-b text-center border-r">New Wt (Ct)</td>
                                </tr>
                              </thead>
                              <tbody v-if="form_data.rejection_details.length > 0">
                                <tr class="border-b bg-gray-100 dark:bg-dark-1">
                                  <th class="p-2 border-b text-xs lg:text-md text-center border-r text-white">.</th>
                                  <td class="p-2 border-b text-center border-r"></td>
                                  <td class="p-2 border-b text-center border-r">{{ form_data.total.cr_pcs }}</td>
                                  <td class="p-2 border-b text-center border-r">{{ form_data.total.cr_weight }}</td>
                                  <td class="p-2 border-b text-center border-r">{{ form_data.total.new_pcs }}</td>
                                  <td class="p-2 border-b text-center border-r">{{ form_data.total.new_weight }}</td>
                                </tr>
                                <tr v-for="(item, index) in form_data.rejection_details" :key="index">
                                  <th class="p-2 border-b text-xs lg:text-md text-center border-r">{{ index + 1 }}</th>
                                  <td class="p-2 border-b text-center border-r">{{ item.lot_no }}<br> ({{
                                    item.voucher_no }})</td>
                                  <td class="p-2 border-b text-center border-r">{{ item.cr_rejection_pcs }}</td>
                                  <td class="p-2 border-b text-center border-r">{{ item.cr_rejection_wt }}</td>
                                  <td class="p-2 border-b text-center border-r"><input type="text"
                                      @keypress="$h.preventInvalidInput" @input="validateDetails(item)"
                                      class="form-control w-24 text-center" v-model="item.new_rejection_pcs">
                                  </td>
                                  <td class="p-2 border-b text-center border-r"><input type="text"
                                      @keypress="$h.preventInvalidInput" @input="validateDetails(item)"
                                      class="form-control w-24 text-center" v-model="item.new_rejection_wt">
                                  </td>
                                </tr>
                              </tbody>
                            </table>

                          </div>
                        </div>
                        <div class="mt-3">
                          <!-- <label class="form-label">Stone && Est Value</label> -->
                          <div class="sm:grid grid-cols-2 gap-2">
                            <div>

                              <div class="">
                                <!-- <div id="input-group-3">Duration</div> -->
                                <!-- <input type="text" class="form-control" @keypress="$h.preventInvalidInput" v-model="form_data.due" placeholder="Duration" aria-describedby="input-group-3" /> -->
                              </div>
                            </div>
                            <div>
                              <div class="mt-2 sm:mt-0">
                                <div class="flex justify-end items-center mt-5">
                                  <button v-if="form_data.purchase_type == 2 && form_data.purchase_select == true"
                                    type="button" @click="form_data.purchase_select = false"
                                    class="btn btn-secondary w-24 m-auto">Back</button>
                                  <button v-if="form_data.purchase_type == 2 && form_data.purchase_select == true"
                                    type="button" @click="add_purchase" :disabled="page_data.loading == true"
                                    class="btn btn-primary w-24 m-auto">{{
                                      form_data.id ? 'Update' : 'Create' }}
                                    <LogInIcon v-if="page_data.loading == false" class="h-4 w-4 ml-2 -mt-1" />
                                    <LoadingIcon v-if="page_data.loading == true" icon="oval" color="white"
                                      class="w-4 h-4 ml-2" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END: Input -->
                </div>
              </div>
              <!-- END: Data List -->
            </div>
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: Single Process Assign Modal -->
  </div>

</template>

<script setup>
/* eslint-disable */
import {
  BASE_URL
} from '@/constants/config'
import {
  useVuelidate
} from '@vuelidate/core'
import axios from 'axios'
import cash from 'cash-dom'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  integer
} from '@vuelidate/validators'
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  reactive,
  ref,
  toRefs,
  watch
} from 'vue'
import {
  helper as $h
} from '@/utils/helper'
// import store from '@/store'
// import ActionDropdown from '@/views/Purchase/components/rough_dropdown.vue'
import router from '@/router'
import Swal from 'sweetalert2'
import {
  useStore
} from '@/store'
// @keypress="$h.preventInvalidInput"

const swal = inject('$swal')
const store = useStore()
const user_details = computed(() => store.state.user.currentUser)
const settings = computed(() => store.state.user.settings)

const page_data = reactive({
  party_details: [],
  purchase_party_details: [],
  loading: false,
  rejection_items: [],
  manager_items: [],
  diamond_type_items: [],
  total: [],
  home_party: "",

  per_ct_allow: true,
  total_allow: false,

})

const form_rules = {
  piece: {
    required,
    integer
  },
  weight: {
    required,

  },
  // kapan: {
  //    required
  // }
}

const form_data = reactive({
  ip: localStorage.getItem('sk_key'),
  id: '',
  party: '0',
  purchase_party: '0',
  diamond_type: '0',
  stone_id: '2',
  piece: '',
  packet_type: 'rough',
  weight: '',
  due: 15,
  kapan: '',
  lot_no: '',
  per_ct_rate: '',
  total_rate: '',
  majuri_type: '2',
  majuri_rate: '',
  margin_percent: '',
  ls_loss_per: '',
  purchase_type: '1',
  purchase_select: false,
  purchase_list: [],
  rejection_details: [],
  total: {
    cr_weight: '',
    new_weight: '',
    cr_pcs: '',
    new_pcs: '',

  },
})

const form_validate = useVuelidate(form_rules, toRefs(form_data))

const add_purchase = async () => {

  if (form_data.purchase_type == 1) {

    form_validate.value.$touch()
    if (form_validate.value.$invalid) {
      // swal('Error', 'Fields are empty.', 'error');
      return
    }
  } else if (form_data.purchase_type == 2) {

    if (form_data.purchase_list.length > 0) {

      for (let i = 0; i < form_data.rejection_details.length; i++) {
        if (form_data.rejection_details[i].new_rejection_wt <= 0 || form_data.rejection_details[i].new_rejection_wt == '' || form_data.rejection_details[i].new_rejection_wt == null) {

          swal('Warning', 'Selected purchase weight must be added.', 'warning')
          return;
        }
      }

      // form_data.rejection_details.forEach(element => {
      //   if(element.new_rejection_wt <= 0 || element.new_rejection_wt == '' || element.new_rejection_wt == null) {

      //     swal('Warning','Selected purchase weight must be added.','warning')
      //     return;
      //   }
      // });
    } else {

      swal('Warning', 'Please, select purchase first.', 'warning');
      return
    }
  }

  const params = form_data

  let promise_url = ''

  if (form_data.id) {
    promise_url = 'api/kpn/up'
  } else {
    promise_url = 'api/kpn/anp'
  }

  page_data.loading = true

  let promise = axios({
    url: promise_url,
    method: "POST",
    data: params,
    baseURL: BASE_URL,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),

    },
    config: {
      headers: {
        Accept: "application/json"
      }
    }
  });
  return promise
    .then(result => result.data)    
    .then(data => {

      if (data.status == 'error') {
        page_data.loading = false
        if (data.type == "warning") {
          update_process_confirm(data.message)
        } else {
          swal('Warning', data.message, 'warning');
        }
      } else {
        swal('Success', data.message, 'success');

        form_data.id = ''
        form_data.purchase_party = '0'
        form_data.diamond_type = '0'
        form_data.stone_id = 2
        form_data.piece = ''
        form_data.weight = ''
        form_data.due = 15
        form_data.kapan = ''
        form_data.lot_no = ''
        form_data.per_ct_rate = ''
        form_data.total_rate = ''
        form_data.purchase_type = '1'
        form_data.purchase_select = false
        form_data.purchase_list = []
        form_data.rejection_details = []
        form_data.majuri_type = '2'
        // form_data.majuri_rate = ''
        // form_data.margin_percent = ''
        form_data.ls_loss_per = ''
        get_margin_costing()
        page_data.loading = false

        cash('#new-rough-purchase-modal').modal('hide')
        form_validate.value.$reset()
        // initTabulator()
      }
    })
    .catch(_error => {
      page_data.loading = false
      swal('Error', 'Something went wrong.', 'error');
    });

}

const update_process_confirm = async (mfg) => {

  swal({
    title: "Are you sure?",
    text: mfg,
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirm",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {

      if (form_data.purchase_type == 1) {

        form_validate.value.$touch()
        if (form_validate.value.$invalid) {
          // swal('Error', 'Fields are empty.', 'error');
          return
        }
      } else if (form_data.purchase_type == 2) {

        if (form_data.purchase_list.length > 0) {

          for (let i = 0; i < form_data.rejection_details.length; i++) {
            if (form_data.rejection_details[i].new_rejection_wt <= 0 || form_data.rejection_details[i].new_rejection_wt == '' || form_data.rejection_details[i].new_rejection_wt == null) {

              swal('Warning', 'Selected purchase weight must be added.', 'warning')
              return;
            }
          }

        } else {

          swal('Warning', 'Please, select purchase first.', 'warning');
          return
        }
      }

      const params = form_data

      let promise_url = ''

      if (form_data.id) {
        promise_url = 'api/kpn/upc'
      } else {
        promise_url = 'api/kpn/anp'
      }

      page_data.loading = true

      let promise = axios({
        url: promise_url,
        method: "POST",
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),

        },
        config: {
          headers: {
            Accept: "application/json"
          }
        }
      });
      return promise
        .then(result => result.data)
        .then(data => {

          if (data.status == 'error') {
            page_data.loading = false
            if (data.type == "warning") {
              update_process_confirm()
            } else {
              swal('Warning', data.message, 'warning');
            }
          } else {
            swal('Success', data.message, 'success');

            form_data.id = ''
            form_data.purchase_party = '0'
            form_data.diamond_type = '0'
            form_data.stone_id = 2
            form_data.piece = ''
            form_data.weight = ''
            form_data.due = 15
            form_data.kapan = ''
            form_data.lot_no = ''
            form_data.per_ct_rate = ''
            form_data.total_rate = ''
            form_data.purchase_type = '1'
            form_data.purchase_select = false
            form_data.purchase_list = []
            form_data.rejection_details = []
            form_data.majuri_type = '2'
            // form_data.majuri_rate = ''
            // form_data.margin_percent = ''
            form_data.ls_loss_per = ''
            page_data.loading = false

            get_margin_costing()
            cash('#new-rough-purchase-modal').modal('hide')
            form_validate.value.$reset()
          }
        })
        .catch(_error => {
          page_data.loading = false
          swal('Error', 'Something went wrong.', 'error');
        });

    }
  });
}


const get_margin_costing = async () => {
  const params = {
    type: window.btoa(form_data.majuri_type)
  }
  axios({
    url: 'api/majuri_costing/get_party_majuri_costing',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    form_data.majuri_rate = res.data.majuri_value.value
    form_data.margin_percent = res.data.margin_value.value
  })
}

const getHomeParty = () => {
  const party = page_data.party_details.find(
    element => element.id == form_data.party
  );

  page_data.home_party = party ? party.home_party : "";
  form_data.stone_id = party ? (party.stone_type ? party.stone_type : "4") : "4";
};

const resetForm = () => {

  cash('#new-rough-purchase-modal').modal('show')

  form_data.id = '';
  form_data.party = '0';
  form_data.purchase_party = '0';
  form_data.diamond_type = '0';
  form_data.stone_id = '2';
  form_data.piece = '';
  form_data.packet_type = 'rough';
  form_data.weight = '';
  form_data.due = 15;
  form_data.kapan = '';
  form_data.lot_no = '';
  form_data.per_ct_rate = '';
  form_data.total_rate = '';
  form_data.majuri_type = '2';
  form_data.majuri_rate = '';
  form_data.margin_percent = '';
  form_data.ls_loss_per = '';
  form_data.purchase_type = '1';
  form_data.purchase_select = false;
  form_data.purchase_list = [];
  form_data.rejection_details = [];
  form_data.total = {
    cr_weight: '',
    new_weight: '',
    cr_pcs: '',
    new_pcs: '',

  }

  loadMasterData();
}

const loadMasterData = () => {
  get_party_details()
  get_purchase_party_details()
  getStones()
  getDiamondTypes()
  get_rejection_details()
}

const get_party_details = () => {

  axios({
    url: 'api/master/dp_parties',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.party_details = res.data.items

    if (user_details.value.user_role == 3) {
      form_data.party = user_details.value.account_id
    } else {

      let party = page_data.party_details[0]
      form_data.party = String(party.id)
    }

    getHomeParty()
  })
}

const getDiamondTypes = () => {
  axios({
    url: 'api/master/dp_diamond_type',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.diamond_type_items = res.data.items
  })
}

const get_purchase_party_details = () => {

  axios({
    url: 'api/master/dp_purchase_parties',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.purchase_party_details = res.data.items

  })
}

const getStones = () => {
  axios({
    url: 'api/master/dp_stone',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    page_data.stones = res.data.items
    form_data.stones = res.data.items
    // console.log('i have stone type')
  })
}

const get_rejection_details = (id) => {
  if (id != 0) {
    const params = {
      user_id: id,
      process_type: window.btoa('bunch')
    }
    if (id != '0') {
      axios({
        url: 'api/kpn/get_rejection_list',
        method: 'post',
        baseURL: BASE_URL,
        data: params,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            'Accept': 'application/json'
          }
        }
      }).then((res) => {
        page_data.rejection_items = res.data.items
      })
    } else {
      page_data.rejection_items = []
    }
  }
}

const get_purchase_data = async (id) => {

  cash('#new-rough-purchase-modal').modal('show')
  
  getStones();
  get_party_details()
  get_purchase_party_details()
  getDiamondTypes()
  const params = {
    id: window.btoa(id),
    ip: localStorage.getItem('sk_key')
  }
  axios({
    url: 'api/kpn/ep',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    form_data.id = window.btoa(res.data.item.id)
    form_data.piece = res.data.item.pr_pcs
    form_data.party = String(res.data.item.party_id)
    form_data.purchase_party = String(res.data.item.purchase_party)
    form_data.diamond_type = String(res.data.item.diamond_type)
    form_data.packet_type = res.data.item.type
    form_data.stone_id = String(res.data.item.stone_type)
    // Add this after setting the form_data.stone_id
// cash('#stone-select-id').val(res.data.item.stone_type).trigger('change');
// setTimeout(() => {
//     form_data.stone_id = res.data.item.stone_type;
//     // If using a custom select component, you may need to call its internal 'refresh' here
// }, 100);
    form_data.weight = res.data.item.pr_wt
    form_data.due = res.data.item.due
    form_data.kapan = res.data.item.voucher_no
    form_data.lot_no = res.data.item.lot_no
    form_data.per_ct_rate = res.data.item.per_ct_rate
    form_data.total_rate = res.data.item.total_rate
    form_data.majuri_rate = res.data.item.majuri_rate
    form_data.margin_percent = res.data.item.margin_percent
    form_data.ls_loss_per = res.data.item.ls_loss_per
    form_data.purchase_type = String(res.data.item.purchase_type)
    form_data.purchase_list = (res.data.item.rejection_id ? res.data.item.rejection_id : [])
    form_data.rejection_details = res.data.item.rejection_list

    if (form_data.purchase_type == 2) {
      calculate_total()
    }
    
  
    // form_data.stone_id = String(res.data.item.stone_type)
  })
}

const calculate_total = () => {
  let cr_weight = 0
  let new_weight = 0
  let cr_pcs = 0
  let new_pcs = 0
  form_data.rejection_details.forEach(element => {

    cr_weight += parseFloat(element.cr_rejection_wt)
    new_weight += (element.new_rejection_wt ? parseFloat(element.new_rejection_wt) : 0)
    cr_pcs += parseFloat(element.cr_rejection_pcs)
    new_pcs += (element.new_rejection_pcs ? parseFloat(element.new_rejection_pcs) : 0)
  });
  form_data.total.cr_weight = $h.myFloat(cr_weight)
  form_data.total.new_weight = $h.myFloat(new_weight)
  form_data.total.cr_pcs = (cr_pcs)
  form_data.total.new_pcs = (new_pcs)
}

const validateDetails = (item) => {

  if (item.cr_rejection_wt < (item.new_rejection_wt ? item.new_rejection_wt : 0)) {
    item.new_rejection_wt = ''
    swal('Warning', 'Weight mush be less then ' + item.cr_rejection_wt + ' Ct')
    return
  }

  calculate_total()

}

watch(() => form_data.purchase_list, (CurrentVal, OldVal) => {
  if (form_data.purchase_list.length > 0) {

    if (CurrentVal.length > OldVal.length) {
      let purchase_id = form_data.purchase_list[CurrentVal.length - 1]

      page_data.rejection_items.forEach(item => {
        if (item.kapan_id == purchase_id) {
          form_data.rejection_details.push({
            id: item.kapan_id,
            rejection_id: item.id,
            lot_no: item.lot_no,
            voucher_no: item.voucher_no,
            cr_rejection_wt: item.cr_rejection_wt,
            cr_rejection_pcs: item.cr_rejection_pcs,
            new_rejection_wt: '',
            new_rejection_pcs: '',
          })
          calculate_total()
        }
      });
      // rejection_details
    } else {
      let purchase_id = OldVal.filter(x => CurrentVal.indexOf(x) === -1);
      let length = form_data.rejection_details.length

      while (length--) {
        if (form_data.rejection_details[length]['id'] == purchase_id[0]) {
          form_data.rejection_details.splice(length, 1);
        }
      }
    }
  }
})

const calculate_purchase_ct = (type) => {

  if(type == 'per_ct_rate') {
    form_data.total_rate = parseFloat(form_data.per_ct_rate * form_data.weight).toFixed(2);
  } else if(type == 'weight') {
  } else if(type == 'total_rate') {

    if(form_data.weight > 0) {
      form_data.per_ct_rate = parseFloat(form_data.total_rate / form_data.weight).toFixed(2);
    } else {
      form_data.per_ct_rate = 0
    }
  }
}

defineExpose({
  resetForm,
  get_purchase_data
})


</script>
